import React from 'react';
import { MenuItem, Select as MUISelect, makeStyles } from '@material-ui/core';
import styled from 'styled-components';

import { SvgIcon, Text } from 'Components/Base';

const useStyles = makeStyles(() => ({
  root: { fontSize: 16 },
  paper: { maxWidth: '250px' },
  icon: { marginRight: 13, fontSize: 25, color: '#637381' },
}));

const SelectMenuItem = (props) => <MenuItem p={0} {...props} />;

const Select = styled(MUISelect)`
  width: 124px;
  height: 56px;
  font-family: ${({ theme }) => `${theme.fonts.sans} !important`};
  border-radius: ${({ theme }) => `${theme.space[2]}px !important`};
  margin-right: 8px;
`;

const ConnectionSelector = ({
  currentAnswer = '',
  handleAnswerSelection,
  answerOptions = [],
  placeholder = 'Select an option',
  ...props
}) => {
  const classes = useStyles();

  const handleOnchange = (e) => {
    const selectedAnswer = e.target.value;
    handleAnswerSelection(selectedAnswer);
  };

  return (
    <Select
      variant="outlined"
      displayEmpty
      MenuProps={{
        classes: { paper: classes.paper },
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        getContentAnchorEl: null,
      }}
      value={currentAnswer}
      IconComponent={SvgIcon.ICON_LIST.ARROW_DOWN}
      onChange={handleOnchange}
      renderValue={(selected) =>
        selected ? (
          selected
        ) : (
          <Text textStyle="body1" color="#637381">
            {placeholder}
          </Text>
        )
      }
      classes={{ root: classes.root, icon: classes.icon }}
      {...props}
    >
      {answerOptions?.length > 0 ? (
        answerOptions.map((answer) => (
          <SelectMenuItem key={answer} value={answer}>
            <Text textStyle="body1" color="#212B36" noWrap>
              {answer}
            </Text>
          </SelectMenuItem>
        ))
      ) : (
        <SelectMenuItem disabled value="">
          <Text textStyle="body1" color="#637381">
            {'ไม่มีตัวเลือก'}
          </Text>
        </SelectMenuItem>
      )}
    </Select>
  );
};

export default ConnectionSelector;
